import {
    navbtn,
} from './../../listeners';
import {
    TimelineMax,
    Power3
} from 'gsap';
import $ from 'jquery';
(function navBarAnimation() {

    let navTimeLine = new TimelineMax({
        paused: true
    });
    navTimeLine.to('.nav-item-1', .3, {
        width: '100%'
    })
    navTimeLine.to('.nav-item-3', .3, {
        width: '100%'
    }, '-=.3')
    navTimeLine.to('.nav-menu', .3, {
        display: 'block',
        width: '100%',
        opacity: 1
    }, '-= .5')

    navTimeLine.staggerFromTo('.nav-menu--container--items ', 1, {
        display: 'none',
        opacity: '0',
        left: '-45%',
        ease: Power3.easeInOut
    }, {
        display: 'block',
        opacity: '1',
        left: '0%',
        ease: Power3.easeInOut
    }, .2, '-= .62')

    navTimeLine.fromTo('.join-family', 1, {
        opacity: 0,
        right: '0',
    }, {
        opacity: 1,
        right: '10%'
    }, 1)
    navTimeLine.fromTo('.join-family span', 1, {
        opacity: 0,
        width: '0',
    }, {
        opacity: 1,
        width: '80%'
    }, 1)





    navTimeLine.reverse()


    navbtn.addEventListener('click', function () {
        navTimeLine.reversed(!navTimeLine.reversed())
        console.log('clicked')
    })

    let menuItems = document.querySelectorAll('.nav-menu--container--items a');
    let menuBtnSvg = document.querySelector('.menuSvg');

    for (let i = 0; i < menuItems.length; i++) {
        menuItems[i].addEventListener('click', function () {
            setTimeout(function(){
                menuBtnSvg.classList.remove('active');
            $(document.body).toggleClass('overFlowHide');

            },500)
            navTimeLine.reversed(!navTimeLine.reversed()).timeScale(2)
        })
    }



    function addActive(){
        menuBtnSvg.classList.toggle('active');
    }   
        $('.menuSvg').click(function(){
            setTimeout(function(){
                addActive()
            },200)
            $(document.body).toggleClass('overFlowHide');
        })

})();